import * as tslib_1 from "tslib";
import { AbstractMethodError } from "../errors/AbstractMethodError";
import { AssetEvent } from "../events/AssetEvent";
import { EventDispatcher } from "../events/EventDispatcher";
var AssetBase = (function (_super) {
    tslib_1.__extends(AssetBase, _super);
    function AssetBase(name) {
        if (name === void 0) { name = null; }
        var _this = _super.call(this) || this;
        _this._id = AssetBase.ID_COUNT++;
        if (name == null)
            name = 'null';
        _this._name = name;
        _this._originalName = name;
        _this.updateFullPath();
        return _this;
    }
    Object.defineProperty(AssetBase.prototype, "adaptee", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssetBase.prototype, "adapter", {
        /**
         * adapter is used to provide MovieClip to scripts taken from different platforms
         * setter typically managed by factory. getter defaults to AwayJS class
         */
        get: function () {
            return this._adapter || this;
        },
        set: function (value) {
            this._adapter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssetBase.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            throw new AbstractMethodError();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssetBase.prototype, "originalName", {
        /**
         * The original name used for this asset in the resource (e.g. file) in which
         * it was found. This may not be the same as <code>name</code>, which may
         * have changed due to of a name conflict.
         */
        get: function () {
            return this._originalName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssetBase.prototype, "id", {
        /**
         * A unique id for the asset, used to identify assets in an associative array
         */
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssetBase.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (val) {
            var prev;
            prev = this._name;
            this._name = val;
            if (this._name == null)
                this._name = 'null';
            this.updateFullPath();
            this.dispatchEvent(new AssetEvent(AssetEvent.RENAME, this, prev));
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    AssetBase.prototype.invalidate = function () {
        this.dispatchEvent(new AssetEvent(AssetEvent.INVALIDATE, this));
    };
    /**
     * @inheritDoc
     */
    AssetBase.prototype.dispose = function () {
        this.dispatchEvent(new AssetEvent(AssetEvent.DISPOSE, this));
    };
    AssetBase.prototype.clear = function () {
        this.dispatchEvent(new AssetEvent(AssetEvent.CLEAR, this));
    };
    Object.defineProperty(AssetBase.prototype, "assetNamespace", {
        get: function () {
            return this._namespace;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssetBase.prototype, "assetFullPath", {
        get: function () {
            return this._full_path;
        },
        enumerable: true,
        configurable: true
    });
    AssetBase.prototype.assetPathEquals = function (name, ns) {
        return (this._name == name && (!ns || this._namespace == ns));
    };
    AssetBase.prototype.isAsset = function (assetClass) {
        return this.assetType == assetClass.assetType;
    };
    AssetBase.prototype.resetAssetPath = function (name, ns, overrideOriginal) {
        if (ns === void 0) { ns = null; }
        if (overrideOriginal === void 0) { overrideOriginal = true; }
        this._name = name ? name : 'null';
        this._namespace = ns ? ns : AssetBase.DEFAULT_NAMESPACE;
        if (overrideOriginal)
            this._originalName = this._name;
        this.updateFullPath();
    };
    AssetBase.prototype.updateFullPath = function () {
        this._full_path = [this._namespace, this._name];
    };
    return AssetBase;
}(EventDispatcher));
export { AssetBase };
AssetBase.ID_COUNT = 0;
AssetBase.DEFAULT_NAMESPACE = 'default';



// WEBPACK FOOTER //
// ../dist/lib/library/AssetBase.js